import { InputLabel, MenuItem, Select, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { useAppSelector } from 'domain/hooks/redux-hook';
import { ErrorMessage } from 'formik';
import ModalContainer from 'presentation/components/ModalContainer';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
    header?: string;
    subHeader?: string;
    open: boolean;
    onClose: () => void;
    applyButton: (data: any) => void;
    data: any;
} 

const EditModal: React.FC<Props> = (props: Props) => {
    const {t} = useTranslation();
    const data = useAppSelector((state) => state.main.setorku.partner.detail);
    const {handleSubmit, setValue, control, formState: {errors}} = useForm()

    return (
        <ModalContainer
            header={props.header ?? "Header"}
            subHeader={props.subHeader ?? "SubHeader"}
            open={props.open}
            onClose={props.onClose}
            applyButton={handleSubmit(props.applyButton)}
            cancelButton={props.onClose}
        >
            <FormControl>
              <Controller
                name="productId"
                control={control}
                defaultValue={data?.partnerId}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t("setorku.product.id_product")}
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled
                  />
                )}
              />
              {errors.productId && (
                <Typography variant="caption" color="error">
                    {t("setorku.product.id_product_required")}
                </Typography>
              )}
            </FormControl>
            <FormControl>
              <Controller
                name="companyId"
                control={control}
                rules={{ required: true }}
                defaultValue={data?.partnerName}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t("setorku.product.company_id")}
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled
                  />
                )}
              />
            </FormControl>
            {errors.companyId && (
                <Typography variant="caption" color="error">
                    {t("setorku.product.company_id_required")}
                </Typography>
            )}
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{t("setorku.partner.is_active")}</InputLabel>
                <Controller
                    name="isActive"
                    control={control}
                    rules={{ required: true }}
                    defaultValue={data?.isActive}
                    render={({ field }) => (
                        <Select
                            {...field}
                            label={t("setorku.partner.is_active")}
                            variant="outlined"
                            labelId="demo-simple-select-label"
                            size="small"
                            sx={{
                                width: "100%",
                            }}
                        >
                            <MenuItem value="1">ACTIVE</MenuItem>
                            <MenuItem value="0">INACTIVE</MenuItem>
                        </Select>
                    )}
                />
                {errors.isActive && (
                    <Typography variant="caption" color="error">
                        {t("setorku.product.id_product_required")}
                    </Typography>
                )}
            </FormControl>
        </ModalContainer>
    );
}

export default EditModal;